import React, { useState } from 'react';
import { Box, Container, Typography } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Navbar from '../../components/Navbar';
import RequireAuth from '../../components/athletes/RequireAuth';
import AthleteForm from '../../components/athletes/AthleteForm';
import { createAthlete } from '../../services/athleteService';

// Only ever an internal path we already know is safe to return to (the
// invite flow) — never an arbitrary redirect target. Anything else falls
// back to the normal "go to the new athlete's profile" behavior.
function safeReturnTo(value) {
  return typeof value === 'string' && value.startsWith('/join/') ? value : null;
}

function CreateAthleteInner() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const returnTo = safeReturnTo(searchParams.get('returnTo'));
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (values) => {
    setError(null);
    setSaving(true);
    try {
      const athlete = await createAthlete(values);
      // Invite continuation (017): a guardian who arrived via /join/:code
      // with no athletes yet is sent back to finish that request instead
      // of landing on the new athlete's profile — the normal destination
      // for every other caller of this page, unchanged.
      navigate(returnTo || `/athletes/${athlete.id}`);
    } catch (e) {
      setError(e.message || 'Could not create athlete.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ py: 4 }}>
      <Typography variant="h4" sx={{ fontWeight: 900, mb: 1 }}>Create Athlete</Typography>
      <Typography sx={{ color: '#9eb8d0', mb: 3 }}>
        Basic athlete information. You can update measurements anytime.
      </Typography>
      <AthleteForm
        onSubmit={handleSubmit}
        submitLabel="Create Athlete"
        onCancel={() => navigate(returnTo || '/athletes')}
        saving={saving}
        error={error}
        includeMeasurements
      />
    </Container>
  );
}

export default function CreateAthletePage() {
  return (
    <Box sx={{ minHeight: '100vh' }}>
      <Navbar />
      <RequireAuth><CreateAthleteInner /></RequireAuth>
    </Box>
  );
}
